import { render, staticRenderFns } from "./paperAnswer.vue?vue&type=template&id=65f1ce54&scoped=true&"
import script from "./paperAnswer.vue?vue&type=script&lang=js&"
export * from "./paperAnswer.vue?vue&type=script&lang=js&"
import style0 from "./paperAnswer.vue?vue&type=style&index=0&id=65f1ce54&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f1ce54",
  null
  
)

export default component.exports